// RespiteCareSection.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import respiteCareImage from '../assets/respite-care-showcase.jpg';

const RespiteCareSection = () => {
  const highlights = ['Short-term relief', 'Daily living help', 'Companionship support'];

  return (
    <section className="bg-bnCream py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div>
            <img
              src={respiteCareImage}
              alt="Carer with elderly woman"
              className="w-full h-[420px] lg:h-[560px] rounded-2xl object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Respite Care
            </p>
            <h3 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Time to Rest, While Care Continues at Home
            </h3>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-8">
              <p>
                Respite care provides temporary relief for family carers while ensuring that seniors continue to receive compassionate, reliable support at home. The carers we match step in to handle daily living tasks, provide companionship, and assist with personal care, allowing family members to rest, recharge, or attend to other responsibilities without worry.
              </p>

              <p>
                With flexible scheduling and personalised care plans, our respite services give families peace of mind knowing their loved ones are in experienced and caring hands. This support not only benefits seniors but also helps carers maintain their own wellbeing, ensuring long-term quality care for the entire family.
              </p>
            </div>

            <ul className="space-y-4">
              {highlights.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-bnAccent text-bnAccent">
                    <ArrowRight size={16} />
                  </span>
                  <span className="text-bnBody text-base leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RespiteCareSection;
